import { Link } from "react-router-dom";
import GrayDotsBackground from "../../containers/BackgroundContainer/GrayDotsBackground";


const items = [
  {
    image: "/images/about/about1.webp",
    title: "KARIJERE",
    route: "/karijere"
  },
  {
    image: "/images/about/about2.webp",
    title: "NOVO INVESTMENT",
    route: "/o-nama"
  },
  {
    image: "/images/about/about3-1.webp",
    title: "GALERIJA",
    route: "/galerija"
  }
]

const HomeAbout = () =>{
  return(
    <>
      <GrayDotsBackground>
        <div className="row justify-content-center d-md-flex mx-auto home-about-container px-3 px-md-1 home-about-cards">
          {items.map((item, key) => {
            return(
              <div className="col-12 col-md about_item_container mb-4 mx-auto" key={key}>
                <Link to={item.route} className="text-decoration-none">
                  <div className="row">
                    <img src={item.image} className="about-item-image" alt=""></img>
                    <div className="title text-start py-4">{item.title}</div>
                  </div>
                </Link>
              </div>
            )
          })}
        </div>
      </GrayDotsBackground>
    </>
  )
}

export default HomeAbout;